export default "__VITE_ASSET__CYz76pnQ__"